module.exports = __webpack_public_path__ + "files/d84169d2641a45465aea741a5aba79e3.png";